import { useMemo } from 'react';
import { MultiSelect, type SelectOption } from '@skupreme/shared/ui';
import type { IDropdownOption } from '@elements/Dropdown';
import { CommonUtility } from '@utility/common';

type MultipleStatusDropdownProps = {
  value: string[];
  dropdownChanged: (value: string[]) => void;
  options: IDropdownOption[];
  loading?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
};

export function MultipleStatusDropdown({
  value,
  dropdownChanged,
  options: data,
  loading,
  disabled,
  placeholder = 'Status',
  className,
}: MultipleStatusDropdownProps) {
  const options = useMemo<SelectOption[]>(
    () =>
      CommonUtility.sortDropdownOptions(data).map(
        (option: IDropdownOption) => ({
          value: String(option.value),
          label: option.text,
        }),
      ),
    [data],
  );

  return (
    <MultiSelect
      aria-label={placeholder}
      placeholder={placeholder}
      options={options}
      values={value}
      onChange={dropdownChanged}
      isDisabled={disabled || loading}
      className={className}
    />
  );
}
